import { createFileRoute, redirect } from '@tanstack/react-router'

// Search redirects to campaigns - search is handled in CampaignIndex
// The search functionality is embedded in the campaigns page
export const Route = createFileRoute('/search')({
  beforeLoad: ({ search }) => {
    // Redirect to campaigns with the search query
    throw redirect({
      to: '/campaigns',
      search: { q: (search as { q?: string }).q },
    })
  },
})
